import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

const ActivationPersonalDataModule = {
  namespaced: true,
  state: {
    person: null,
    address: null,
    additional: null,
    identInformation: null,
    friendState: true
  },
  getters: {
    friendState: state => {
      return state.friendState
    },
    personal: state => {
      return state.person
    },
    firstName: state => state.person?.firstName,
    lastName: state => state.person?.lastName,
    birthDate: state => state.person?.birthDate,
    email: state => state.additional?.email,
    address: state => {
      return state.address
    },
    additional: state => {
      return state.additional
    },
    identificationFull: state => {
      return state.identInformation
    },
    identificationCore: state => {
      return {
        identMethod: state.identInformation.identType,
        nationality: state.identInformation.nationality.iso3,
        medium: state.identInformation.identCard.key
      }
    },
    validateAddressCore: (state, getters, rootState, rootGetters) => {
      return {
        firstName: getters.personal.firstName,
        lastName: getters.personal.lastName,
        gender: getters.personal.gender,
        brand: rootGetters.brand,
        market: rootGetters['activation/info/market'],
        tariffIdentifier: getters.tariffIdentifier,
        retailerId: rootGetters.retailerId,
        type: rootGetters.deliveryType,
        birthDate: getters.personal.birthDate
      }
    },
    tariffIdentifier: (state, getters, rootState, rootGetters) => {
      if (rootGetters['activation/tariff/tariffId']) {
        return rootGetters['activation/tariff/tariffId']
      }
      return rootGetters['activation/info/tariffIdentifier']
    }
  },
  actions: {
    async validate ({ dispatch, commit, state, getters, rootGetters }, { person, address, identInformation, additional, friendMsisdn, nextStep }) {
      commit('clearMessages', {}, { root: true })
      commit('storePersonalData', person)
      commit('storeIdent', identInformation)
      commit('storeAdditional', additional)
      if (friendMsisdn !== '') {
        dispatch('friendNotification/checkReferFriend', {
          existingCustomerMsisdn: friendMsisdn,
          newCustomerMsisdn: rootGetters['activation/info/msisdn'],
          processName: 'activation'
        }, { root: true }).then((response) => {
          if (response.success) {
            commit('storeFriendState', true)
          } else {
            commit('storeFriendState', false)
            commit('addError', response, { root: true })
          }
        })
      } else {
        commit('storeFriendState', true)
        commit('friendNotification/existingCustomerMsisdn', friendMsisdn, { root: true })
      }
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation activation ($validateAddressInput: ValidateAddressInput!) {
          validateAddress (validateAddressInput: $validateAddressInput){
            address {
              street,
              houseNumber,
              zip,
              city,
              supplement
            }
          }
        }`,
        variables: {
          validateAddressInput: {
            ...getters.validateAddressCore,
            address: address
          }
        }
      }).then((response) => {
        if (response.data.validateAddress.address) {
          // das supplement wird nicht von magam zurückgegeben bei der validierung, taucht aber später wieder auf
          commit('storeAddress', Object.assign({ supplement: address.supplement }, response.data.validateAddress.address))
          if (state.friendState) {
            return dispatch('activation/submit/activationInitiate', {}, { root: true }).then(() => {
              commit('activation/goToStep', nextStep, { root: true })
            })
          }
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    storeFriendState (state, friendState) {
      state.friendState = friendState
    },
    storePersonalData (state, person) {
      state.person = {
        gender: person.gender,
        firstName: person.firstName,
        lastName: person.lastName,
        birthDate: person.birthDate
      }
    },
    storeAddress (state, address) {
      state.address = {
        street: address.street,
        houseNumber: address.houseNumber,
        zip: address.zip,
        city: address.city,
        supplement: address.supplement
      }
    },
    storeIdent (state, identInfo) {
      state.identInformation = {
        identCard: identInfo.identCard,
        nationality: identInfo.nationality,
        identType: identInfo.identType,
        dataMatchIdent: identInfo.dataMatchIdent
      }
    },
    storeAdditional (state, additional) {
      state.additional = {
        email: additional.email,
        password: additional.password
      }
    }
  }
}

export default ActivationPersonalDataModule
